import { createRef, useEffect, useRef, useState } from "react";
import { BsMusicNoteBeamed } from "react-icons/bs";
import "../styles/container.scss";
import BgFragment from "./BgFragment";
import { randRange } from "../helpers/helpers";
import { getRandomFragment, patterns } from "../helpers/fragments";

import { fragments_config } from "../config/settings";

const { COLUMNS, ROWS, ICON_SIZE, COLOR } = fragments_config;

function Container({ pattern, children }) {
   const [populatedPages, setPopulatedPages] = useState(0);
   const [fragments, setFragments] = useState([]);
   const [populated, setPopulated] = useState(false);

   useEffect(() => {
      for (let i = 0; i < ROWS * COLUMNS; i++) {
         const ref = createRef();
         fragments.push([
            <BgFragment
               icon={getRandomFragment(ICON_SIZE, COLOR)}
               posX={-100}
               posY={-100}
               ref={ref}
               color={COLOR}
            />,
            ref,
         ]);
      }
      setPopulated(true);
      setTimeout(() => deployFragments(), 10);
   }, []);

   useEffect(() => {
      populated && deployFragments(pattern);
   }, [pattern]);

   function deployFragments() {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const block_width = viewportWidth / COLUMNS;
      const block_height = viewportHeight / ROWS;
      let deployment_func;
      if(pattern in patterns){
         deployment_func = patterns[pattern];
         deployment_func({ fragments, block_width, block_height, ROWS, COLUMNS });
      } else {
         deployment_func = patterns.text;
         console.log(pattern);
         deployment_func({ fragments, block_width, block_height, ROWS, COLUMNS, text: pattern });
      }
   }

   return (
      <div className="page">
         <div className="container">{fragments.map((el) => el[0])}
         </div>
         {children}
      </div>
   );
}

export default Container;
